export const ActionTypes = {
  updateSubcategory: "updateSubcategory",
  deleteSubcategory: "deleteSubcategory",
  createSubcategory: "createSubcategory",
  getUserSubcategories: "getUserSubcategories",
  getAllSubcategories: "getAllSubcategories",
}
